import PrimeVue from 'primevue/config';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import ToastService from 'primevue/toastservice';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Tooltip from 'primevue/tooltip';
import VueSocialSharing from 'vue-social-sharing';
import { createI18n } from 'vue-i18n';

// Create i18n instance with options
import messages from '@/assets/i18n/messages.json';
export const i18n = createI18n<false>({
  legacy: false, // you must set `false`, to use Composition API
  locale: 'de', // set locale
  fallbackLocale: 'de', // set fallback locale
  messages, // set locale messages
  globalInjection: true, // enable injection of global vars
});

// function to register components on app
export function registerRequirementsOn(app: any) {
  /**
   * Per T16975, both host application and widget may use hashparams in address bar, but some widgets do not need routing capabilities (e.g. Timeline)
   * Therefore, we use class `wdw-no-router` to differentiate between widgets that need router and the others that don't need it
   *
   * If the div class contains wdw-no-router, it means that the loaded widget requires no router capabilities
   * * */
  app.use(PrimeVue);
  app.use(ToastService);
  app.use(VueSocialSharing);

  // https://github.com/cure53/DOMPurify/issues/317#issuecomment-912474068

  const TEMPORARY_ATTRIBUTE = 'data-temp-href-target';
  app.use(VueDOMPurifyHTML, {
    hooks: {
      beforeSanitizeAttributes: function (node: any) {
        if (node.tagName === 'A') {
          if (!node.hasAttribute('target')) {
            node.setAttribute('target', '_self');
          }

          if (node.hasAttribute('target')) {
            node.setAttribute(TEMPORARY_ATTRIBUTE, node.getAttribute('target'));
          }
        }
      },
      afterSanitizeAttributes: function (node: any) {
        if (node.tagName === 'A' && node.hasAttribute(TEMPORARY_ATTRIBUTE)) {
          node.setAttribute('target', node.getAttribute(TEMPORARY_ATTRIBUTE));
          node.removeAttribute(TEMPORARY_ATTRIBUTE);
          if (node.getAttribute('target') === '_blank') {
            node.setAttribute('rel', 'noopener');
          }
        }
      },
    },
  });
  app.use(i18n);
  app.directive('tooltip', Tooltip);
  app.component('Accordion', Accordion);
  app.component('AccordionTab', AccordionTab);
  app.component('font-awesome-icon', FontAwesomeIcon);
}
